import type { InjectionKey, ComputedRef, WritableComputedRef } from 'vue'

export interface SgPageContext {
  currentPage?: WritableComputedRef<number>
  pageCount?: ComputedRef<number>
  disabled?: ComputedRef<boolean>
  changeEvent?: (val: number) => void
  handleSizeChange?: (val: number) => void
}

export const PageContextKey: InjectionKey<SgPageContext> = Symbol('PageContextKey')
